import { FC, useMemo } from 'react'
import { parseTransactions } from 'lib/helpers/utilities'
import { useConciliationsContainerContext } from 'containers/Conciliations/ConciliationsContainer/ConciliationsContainer'
import GridTableFooter from '../GridTableFooter/GridTableFooter'
import './styles.scss'

const AccountMovementsTableFooter: FC = () => {
  const { statements } = useConciliationsContainerContext()

  const { statementRows, selectedStatementRows, activeStatementRow } =
    statements

  const rows = useMemo(() => {
    const filtered = statementRows.find(
      row => row.idFileBankStatement === activeStatementRow
    )
    return parseTransactions(filtered?.transactions ?? [])
  }, [statementRows, activeStatementRow])

  const hasRows = useMemo(() => statementRows.length > 0, [statementRows])

  const actualSelected = useMemo(() => {
    return rows
      .filter(
        row =>
          selectedStatementRows.includes(row.id) && row.conciliated === false
      )
      .map(row => row.id)
  }, [selectedStatementRows, rows])

  if (!hasRows) {
    return null
  }

  return <GridTableFooter rows={rows} selectedRows={actualSelected} />
}

export default AccountMovementsTableFooter
